import React from 'react';
import ReactHtmlParser, {domToReact} from 'html-react-parser';  //'react-html-parser';

export default ({data = ''}) => {
  let Component = ReactHtmlParser(data, {
    replace: function(domNode) {
      if (domNode.type === 'script') {
        console.log('htmlparse script ', domNode)
        var script = document.createElement('script');
        if(domNode.attribs.src) script.src = domNode.attribs.src;
        if(domNode.children) script.innerHTML = domToReact(domNode.children); //, options
        script.onload = function() {
          console.log('scripts loaded:');
        };
        // document.head.appendChild(script);
      }
    }
  })

  return (<>{Component}</>)
}
